import { render, staticRenderFns } from "./unblockPage.vue?vue&type=template&id=135d0f26&scoped=true&"
import script from "./unblockPage.vue?vue&type=script&lang=js&"
export * from "./unblockPage.vue?vue&type=script&lang=js&"
import style0 from "./unblockPage.vue?vue&type=style&index=0&id=135d0f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d0f26",
  null
  
)

export default component.exports